import { SelectHTMLAttributes } from "react";

export type SelectOption = { key: string; value: string };

export type SelectProps = {
  options: SelectOption[];
} & SelectHTMLAttributes<HTMLSelectElement>;

export function Select({ options, className, ...props }: SelectProps) {
  return (
    <div
      className={[
        "relative bg-transparent border border-antique-brass-500 rounded-tl-md rounded-br-md",
        className,
      ].join(" ")}
    >
      <select
        className={
          "w-full h-full bg-transparent text-antique-brass-500 text-lg placeholder-antique-brass-500 py-3 ps-4 pe-10 outline-none cursor-pointer"
        }
        {...props}
      >
        {options.map((option) => (
          <option key={option.key} value={option.key}>
            {option.value}
          </option>
        ))}
      </select>
    </div>
  );
}
